import { useParams, NavLink } from 'react-router-dom';
import { getTranslate } from '../../../utils/getTranslate/getTranslate';
import { getLocalPath } from '../../../utils/getLocatPath/getLocalPath';
import styles from '../Museum.module.scss';

export const Fullscreen = ({ upPage }) => {
  const t = getTranslate;
  const l = getLocalPath;
  const { lang } = useParams();
  const { icon, toptitle, title, subtitle, text, pdf } = upPage.acf.fullscreen;

  const scrollToAbout = (e) => {
    e.preventDefault();
    const element = document.getElementById('about');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  };
  const scrollToCome = (e) => {
    e.preventDefault();
    const element = document.getElementById('come');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  };

  return (
    <section className={styles.fullscreen}>
      <div className="container">
        <div className={styles.fullscreen_body}>
          <div className={styles.fullscreen_wallpaper}>
            <div className={styles.fullscreen_wallpaper_body}>
              <div className={`${styles.fullscreen_wallpaper_icon} one`}>📖</div>
              <div className={`${styles.fullscreen_wallpaper_icon} two`}>✏️</div>
              <div className={`${styles.fullscreen_wallpaper_icon} three`}>🌟</div>
              <div className={`${styles.fullscreen_wallpaper_icon} four`}>🔖</div>
            </div>
          </div>
          <div className={styles.fullscreen_content}>
            <div className={styles.fullscreen_icon}>{icon}</div>
            <h2 className={styles.fullscreen_toptitle}>{toptitle[lang]}</h2>
            <h1 className={styles.fullscreen_title}>{title[lang]}</h1>
            <h3 className={styles.fullscreen_subtitle}>{subtitle[lang]}</h3>
            <p className={styles.fullscreen_text}>{text[lang]}</p>
            <div className={styles.fullscreen_btns}>
              <a href="#about" className={styles.fullscreen_btn} onClick={scrollToAbout}>
                🗺️ {t('Саяхатты бастау', 'Начать путешествие', lang)}
              </a>
              <a href={pdf} target="_black" className={styles.fullscreen_btn}>
                📖 {t('Зерттеңіз', 'Исследуйте', lang)}
              </a>
              <a href="#come" className={styles.fullscreen_btn} onClick={scrollToCome}>
                📍 {t('Қалай келуге болады', ' Как посетить', lang)}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
